import React, { useEffect, useState } from 'react'
import CardProduct from './CardProduct'
import { Typography, Grid, Button, Link } from '@mui/material'
import axios from 'axios'
import config from '../config'

export default function ContentDownload() {
  const [productList, setProductList] = useState([])
  useEffect(() => {
    axios
      .get(
        `${config.url}/products?sort=desc&sortBy=total_download&offset=0&limit=4`,
        config.token
      )
      .then((res) => {
        setProductList(res.data.data)
      })
  }, [])

  return (
    <React.Fragment>
      <Grid
        container
        spacing={2}
        style={{
          background: '#660066',
          marginTop: '20px',
          marginBottom: '20px',
          paddingBottom: '40px',
          paddingTop: '40px',
          minHeight: '300px',
        }}
        direction='row'
      >
        <Grid item xs={1} />
        <Grid item xs={10} container spacing={2}>
          <Grid item xs={12} md={12} lg={4}>
            <Typography sx={{ color: '#fff', fontWeight: 'bold' }} variant='h4'>
              Our
              <br /> Top 4
            </Typography>
            <Typography
              variant='body2'
              sx={{ color: '#fff', pt: '20px', pb: '20px' }}
            >
              Most downloaded apps
            </Typography>

            <Button
              variant='outlined'
              sx={{ color: '#fff', border: '1px solid #fff' }}
            >
              Show All
            </Button>
          </Grid>

          {productList?.map((value, idx) => (
            <Grid
              item
              xs={3}
              // sm={2}
              md={4}
              lg={2}
              key={idx}
              container
              spacing={2}
              sx={{ mt: '20px' }}
            >
              <Link href={`/detail/${value.id}`} underline='none'>
                <CardProduct data={value} content='download' />
              </Link>
            </Grid>
          ))}
        </Grid>

        <Grid item xs={1} />
      </Grid>
    </React.Fragment>
  )
}
